((app) => {
    app.component("policyInfoList", {
        templateUrl: "/App/States/Policies/Detail/PolicyInfoList/policy.info.list.html",
        controller: "infoCardCtrl",
        bindings: {
            cardTitle: "@",
            isExpanded: "=",
            isDisabled: "=",
            data: "<",
            selectors: "<",
            query: "<",
            initQuery: "<"
        }
    });
})(window.app);
